import { Time } from '@angular/common';

export class Checkin {
    cid: number;
    chktime: Time;
    chkpat: number;
    chkdr: number;
    chkstatus: string;
    chkdate: Date;
    aid: number;
    patid: number;
    pat_name: string;
    doc_name: string;
    apdate: Date;
    aptime: Time;
    date: Date;
    timetz: Time;
    dob: Date;
    special_remarks: string;
    chkindate:Date;
    chkoutDate: Date;
    chkinby:number;
    chkoutby:number;
}
